import React from 'react';
import { t } from 'ttag';
import { select } from '~/lib/select';
import { Button } from '~/ui/buttons/Button';
import { Flex } from '~/ui/flex/Flex';
import { TrainingState, useTrainingStore } from '../../state';
import { OnboardingStages, useOnboardingStore } from '../Store';
import { useNextSequence } from '~/training/useNextSequence';

const selector = (s: TrainingState) =>
  select(s, 'disclaimer', 'onboarding', 'scorePassingPercent');

export const Disclaimer = () => {
  const { stage, next } = useOnboardingStore();
  const { disclaimer, onboarding, scorePassingPercent } =
    useTrainingStore(selector);
  const nextSequence = useNextSequence();

  const GoNext = () => {
    if (scorePassingPercent && scorePassingPercent > 0) {
      return next();
    }

    if (onboarding) {
      if (!scorePassingPercent) {
        next();
      }
      return next();
    } else {
      nextSequence().then();
    }
  };

  return (
    <Flex
      variant="list"
      justifyContent="space-between"
      data-test-id="disclaimer-card"
    >
      <h2>{t`Disclaimer`}</h2>
      {disclaimer && <small dangerouslySetInnerHTML={{ __html: disclaimer }} />}
      <Button
        onClick={GoNext}
        disabled={stage !== OnboardingStages.Disclaimer}
        aria-hidden={stage !== OnboardingStages.Disclaimer}
        data-test-id="agree-button"
      >
        {t`I Agree`}
      </Button>
    </Flex>
  );
};
